//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import baseInfo from './components/baseInfo';
import gridMenu from './components/gridMenu';
import visitChart from './components/visitChart';
import userChart from './components/userChart';
import userOverview from './components/userOverview';
import userFuka from './components/userFuka';
import { checkPermi } from '@/utils/permission'; // 权限判断函数
import { authCertQuery } from '@/api/authInformation';
import { getAuthHostApi } from '@/api/systemConfig';
import Cache from '@/plugins/cache';
import Cookies from 'js-cookie';
export default {
  name: 'Dashboard',
  components: {
    baseInfo: baseInfo,
    gridMenu: gridMenu,
    visitChart: visitChart,
    userChart: userChart,
    userOverview: userOverview,
    userFuka: userFuka
  },
  data: function data() {
    return {
      authStatus: null,
      authHost: '',
      authQueryStatus: false,
      notInformation: null,
      homeType: false,
      miniProgramCustomer: false,
      defaultCustomerId: null
    };
  },
  created: function created() {
    var JavaInfo = JSON.parse(Cookies.get('JavaInfo'));
    this.defaultCustomerId = JavaInfo.customerId;
    console.log(JavaInfo.homeType);
    this.homeType = JavaInfo.homeType === 2; //2为普通用户  1为管理员  5为小程序客户
    this.miniProgramCustomer = JavaInfo.type === 5;
    console.log(this.homeType);
  },
  mounted: function mounted() {
    if (window.location.host.indexOf('localhost') == -1) {
      this.authStatus = Cache.local.has('auth-information') ? Cache.local.getJSON('auth-information') : null;
      this.notInformation = Cache.local.has('not-information') ? Cache.local.getJSON('not-information') : null;
      if (!this.authStatus) {
        this.getUniq();
      }
    }
  },
  methods: {
    checkPermi: checkPermi,
    authInformationQuery: function authInformationQuery() {
      var _this = this;
      authCertQuery({
        host: this.authHost
      }).then(function (res) {
        var oneDay = 24 * 3600 * 1000;
        if (res.data.status == -1 || res.data.status == 2) {
          Cache.local.setItem({
            name: 'not-information',
            value: true,
            expires: oneDay
          });
          if (!notInformation) {
            _this.$modal.confirm(res.data.msg).then(function () {
              _this.$router.push({
                path: '/maintain/authCRMEB'
              });
            }).catch(function () {});
          }
        } else if (res.data.status == 1) {
          _this.$modal.msgSuccess(res.data.msg);
          Cache.local.setItem({
            name: 'auth-information',
            value: true,
            expires: oneDay * 7
          });
        } else if (res.data.status == 3 || res.data.status == 0) {
          _this.$modal.msg(res.data.msg);
        }
      });
    },
    getUniq: function getUniq() {
      var _this2 = this;
      getAuthHostApi({
        key: 'authHost'
      }).then(function (res) {
        _this2.authHost = res.value;
        if (res.value !== '') {
          _this2.authInformationQuery();
        } else {
          _this2.$modal.confirm('您尚未提交授权申请').then(function () {
            _this2.$router.push({
              path: '/maintain/authCRMEB'
            });
          });
        }
      });
    }
  }
};